module.exports = __webpack_public_path__ + "img/niu7.dee029ab.jpg";